import { render, staticRenderFns } from "./MessageAlerts.vue?vue&type=template&id=5affe00e"
import script from "./MessageAlerts.vue?vue&type=script&lang=js"
export * from "./MessageAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports